import React from 'react';
import { Router } from '@reach/router';

import CaseSearchPage from '../../features/admin/search/CaseSearchPage';
import { MemberProfilePage } from '../../features/members/profiles/MemberProfilePage';
import appPaths from '../../appPaths';
import MemberReferralsPage from '../../features/members/referrals/MemberReferralsPage';
import MemberQuotesPage from '../../features/members/quotes/MemberQuotesPage';
import MemberBookingsPage from '../../features/members/bookings/MemberBookingsPage';
import MemberTimesheetsPage from '../../features/members/timesheets/MemberTimesheetsPage';
import MemberInvitePage from '../../features/members/invitations/MemberInvitePage';
import MemberAvailabilityPage from '../../features/members/calendar/MemberAvailabilityPage';
import MemberPipelinePage from '../../features/members/pipeline/MemberPipelinePage';
import MemberPreferencesPage from '../../features/members/preferences/MemberPreferencesPage';
import CaseInfoPage from '../../features/members/cases/CaseInfoPage';
import ClientOrganizationsPage from '../../features/organizations/ClientOrganizationsPage';
import ClientOrganizationPage from '../../features/organizations/ClientOrganizationPage';
import ReferralQuotePage from '../../features/members/quotes/ReferralQuotePage';
import DeclineReferralPage from '../../features/members/referrals/DeclineReferralPage';
import TimesheetEntryPage from '../../features/members/timesheets/TimesheetEntryPage';
import MemberDirectoryPage from '../../features/members/directory/MemberDirectoryPage';
import MemberPage from '../../features/members/directory/MemberPage';
import MemberMiniMenu from '../../features/members/menus/MemberMiniMenu';
import InvoicePreviewPage from '../../features/members/invoices/InvoicePreviewPage';
import MemberInvoicesPage from '../../features/finance/invoices/MemberInvoicesPage';
import SalesInvoicesPage from '../../features/finance/invoices/SalesInvoicesPage';
import PurchaseInvoicePage from '../../features/members/invoices/PurchaseInvoicePage';
import SalesInvoicePage from '../../features/members/invoices/SalesInvoicePage';
import ReferralReviewPage from '../../features/members/referrals/ReferralReviewPage';
import UserDirectoryPage, { UserDirectoryPagePath } from '../../features/members/directory/UserDirectoryPage';
import MailPage, { MailPagePath } from '../../features/admin/mail/MailPage';
import CreateReferralPage from '../../features/members/diy/CreateReferralPage';
import XeroLinkOrganizationPage from '../../features/admin/xero/XeroLinkOrganizationPage';
import XeroLinkMemberPage from '../../features/admin/xero/XeroLinkMemberPage';

import SettingsPage from '../../features/admin/settings/SettingsPage';
import CreateReferrerPage from '../../features/admin/referrers/CreateReferrerPage';
import CreateOrganizationPage from '../../features/admin/referrers/CreateOrganizationPage';
import ErrorLogPage from '../../features/admin/logs/ErrorLogPage';
import CourtsPage from '../../features/admin/courts/CourtsPage';

import ReferralSearchPage from '../../features/admin/search/referrals/ReferralSearchPage';

const MemberAppRoutes = () => {
    return (
        <Router>
            <MemberPipelinePage default />
            <ErrorLogPage path="/admin/logs/errors" />
            <MemberMiniMenu path="/snafu" />
            <MemberDirectoryPage path={appPaths.admin.members} />
            <MemberPage path="/members/:intermediaryId" />
            <ClientOrganizationsPage path={appPaths.admin.organizations} />
            <ClientOrganizationPage path="/admin/organization/:id" />
            <ClientOrganizationPage path={appPaths.admin.newOrganization} />
            <MailPage path={MailPagePath} />
            <MemberProfilePage path={appPaths.members.profile} />

            <MemberReferralsPage path={appPaths.casework.referrals} />
            <ReferralQuotePage path={appPaths.casework.quote} />
            <ReferralReviewPage path="/casework/referral/:referralId" />
            <DeclineReferralPage path="/casework/referral/decline/:requestId" />

            <MemberQuotesPage path={appPaths.casework.quotes} />
            <MemberBookingsPage path={appPaths.casework.bookings} />
            <MemberTimesheetsPage path={appPaths.casework.timesheets} />
            <InvoicePreviewPage path="/casework/invoices/:timesheetId" />
            <MemberPipelinePage path="/" />
            <MemberPipelinePage path="/members/home" />
            <MemberPipelinePage path={appPaths.casework.dashboard} />
            <MemberInvitePage path={appPaths.members.invite} />
            <MemberAvailabilityPage path={appPaths.members.calendar} />
            <MemberPreferencesPage path={appPaths.members.preferences} />
            <TimesheetEntryPage path="/casework/timesheets/:bookingId" />
             
            <MemberInvoicesPage path="/finance/purchase_invoices" />
            <SalesInvoicesPage path="/finance/sales_invoices" />
            <PurchaseInvoicePage path="/organizations/:organizationId/purchase_invoices/:invoiceId" />
            <SalesInvoicePage  path="/organizations/:organizationId/sales_invoices/:invoiceId" />
            <UserDirectoryPage path={UserDirectoryPagePath} />

            <XeroLinkOrganizationPage path="/admin/finance/xorg" />
            <XeroLinkMemberPage path="/admin/finance/xmembers" />

            <SettingsPage path="/admin/settings" />

            <CaseInfoPage path="casework/info/:uid" />
            <CaseInfoPage path="casework/info" />

            <CreateReferrerPage path="/admin/referrer" />
            <CreateOrganizationPage path="/admin/sra/referrers" />

            <CreateReferralPage path="/casework/diy/referral" />

            <CourtsPage path="/admin/courts" />
            <CaseSearchPage path="/admin/cases/search" />
            <ReferralSearchPage path="/admin/referrals/search" />
        </Router>
    );
}

export default MemberAppRoutes;